import { Flex, Box, Text, Image } from "rebass/styled-components";
import { format } from "date-fns";
import Rating from "../common/Rating";
import Link from "../common/Link";
import LiveAvatar from "../common/LiveAvatar";
import theme from "../../lib/theme";
import { Review } from "../../generated/graphql";

interface Props {
  link?: {
    id: string;
    title: string;
  };
  review: Review;
}

const ReviewCard = ({ review, link }: Props) => {
  const { sizes } = theme;

  return (
    <Box
      py={3}
      sx={{
        borderBottom: "default"
      }}
      itemProp="review"
      itemScope
      itemType="http://schema.org/Review"
    >
      <Box width={1} px={[2, 2, 0]}>
        <Flex flexWrap="wrap">
          <Box width={[2 / 8, 1 / 8]}>
            {link ? (
              <Link
                href={{
                  pathname: "/sitterprofile",
                  query: {
                    id: link.id,
                    title: link.title
                  }
                }}
              >
                <Image
                  src={review.author.avatar?.thumb}
                  height="auto"
                  variant="avatar"
                  alt={`${review.author.name} avatar`}
                  size="thumb"
                  style={{
                    cursor: "pointer"
                  }}
                />
              </Link>
            ) : (
              <LiveAvatar
                src={review.author.avatar?.thumb}
                size={sizes.thumb}
                name={review.author.id}
                alt={`${review.author.name} review`}
              />
            )}
          </Box>

          <Box width={[6 / 8, 7 / 8]} pl={1}>
            <Text
              as="p"
              fontWeight="book"
              fontSize={3}
              itemProp="author"
              itemType="http://schema.org/Person"
              itemScope
            >
              <Box as="span" itemProp="name" content={review.author.name}>
                {review.author.name}
              </Box>
            </Text>
            <Text as="span" itemProp="datePublished">
              {format(new Date(review.createdAt), "MMMM yyyy")}
            </Text>
            <Rating
              score={review.score}
              itemProp="reviewRating"
              itemScope
              itemType="http://schema.org/Rating"
            >
              <meta itemProp="ratingValue" content={`${review.score}`} />
              <meta itemProp="bestRating" content={`5`} />
              <meta itemProp="worstRating" content={`1`} />
            </Rating>
          </Box>
        </Flex>
        {review.content && (
          <Flex>
            <Box mt={2}>
              <Text as="p" itemProp="reviewBody">
                {review.content}
              </Text>
            </Box>
          </Flex>
        )}
      </Box>
    </Box>
  );
};

export default ReviewCard;
